const clusterColors = {
  // same color as assets/icons/networks-status/equalizador-disconnected.png
  wineColor: '#A61C00',
  // same color as assets/icons/networks-status/equalizador-null.png
  redColor: '#FD0100',
  // same color as assets/icons/networks-status/equalizador-low.png
  orangeColor: '#FF9900',
  // same color as assets/icons/networks-status/equalizador-good.png
  yellowColor: '#EEFF41',
  // same color as assets/icons/networks-status/equalizador-optimum.png
  greenColor: '#1BF91C',
  // same color as assets/icons/networks-status/neighbors-equalizador-good.png
  lightGreenColor: '#A4FF00',
};

const panelNeighColors = {
  // same color as assets/icons/networks-status/neighbors-equalizador-disconnected.png
  wine: '%23A61C00',
  disconnected: '%23A61C00', // for the clusters
  // same color as assets/icons/networks-status/neighbors-equalizador-null.png
  null: '%23FF9900',
  // same color as assets/icons/networks-status/neighbors-equalizador-low.png
  low: '%23EEFF41',
  // same color as assets/icons/networks-status/neighbors-equalizador-good.png
  good: '%23A4FF00',
  // same color as assets/icons/networks-status/neighbors-equalizador-optimum.png
  optimum: '%231Bf91C',
};

const panelNormalColors = {
  null: '%23FD0100',
  low: '%23FF9900',
  good: '%23EEFF41',
  optimum: '%231EF61E',
  gray: '%23E6E6E6',
};

const panelNormalGrayscale = {
  null: '%23424242',
  low: '%23757575',
  good: '%239E9E9E',
  optimum: '%23E0E0E0',
  gray: '%23E6E6E6',
};

const panelNeighGrayscale = {
  wine: '%23424242',
  null: '%23757575',
  low: '%239E9E9E',
  good: '%23BDBDBD',
  optimum: '%23E0E0E0',
};

const icons = {
  linkRF: {
    typeInterior: (color, scale, opacity) => getRFIIcon(color, scale, opacity),
    typeExteriorLow: (color, scale, opacity) => getRFELIcon(color, scale, opacity),
    typeExteriorHigh: (color, scale, opacity) => getRFEHIcon(color, scale, opacity),
  },
  linkWifiEth: {
    typeInterior: (color, scale, opacity) => getWifiEthIIcon(color, scale, opacity),
    typeExteriorLow: (color, scale, opacity) => getWifiEthELIcon(color, scale, opacity),
    typeExteriorHigh: (color, scale, opacity) => getWifiEthEHIcon(color, scale, opacity),
  },
  linkCelular: {
    typeInterior: (color, scale, opacity) => getCelularIIcon(color, scale, opacity),
    typeExteriorLow: (color, scale, opacity) => getCelularELIcon(color, scale, opacity),
    typeExteriorHigh: (color, scale, opacity) => getCelularEHIcon(color, scale, opacity),
  },
  linkFull: {
    typeInterior: (color, scale, opacity) => getFullIIcon(color, scale, opacity),
    typeExteriorLow: (color, scale, opacity) => getFullELIcon(color, scale, opacity),
    typeExteriorHigh: (color, scale, opacity) => getFullEHIcon(color, scale, opacity),
  },
  leftSidePanelStatusLeds: {
    typeDeviceState: (color, scale, opacity) => getFullDeviceSignalIcon(color, scale),
    typeReceiverState: (color, scale, opacity) => getFullReceiverIcon(color, scale),
    typeMonitoringState: (color, scale, opacity) => getFullMonitoringIcon(color, scale),
  },
};

const getIconCode = (type, installation, status, isNeighbor, grayscale = false, solid = false, scale = 1) => {
  const colorCode = grayscale ? getGrayscaleColor(status, isNeighbor) : getColor(status, isNeighbor, solid);
  return icons[type][installation](colorCode.color, scale, colorCode.opacity);
};

const getColor = (status, isNeighbor, solid) => {
  if (isNeighbor) {
    switch (status) {
      case 'wine':
      case 'null':
      case 'low':
      case 'good':
        return { color: panelNeighColors[status], opacity: 1 };
      case 'optimum':
        return { color: panelNeighColors[status], opacity: solid ? 1 : 0.5 };
    }
  } else {
    switch (status) {
      case 'null':
      case 'low':
      case 'good':
      case 'gray':
        return { color: panelNormalColors[status], opacity: 1 };
      case 'optimum':
        return { color: panelNormalColors[status], opacity: solid ? 1 : 0.5 };
    }
  }
};

const getGrayscaleColor = (status, isNeighbor) => {
  if (isNeighbor) {
    switch (status) {
      case 'wine':
      case 'null':
      case 'low':
      case 'good':
        return { color: panelNeighGrayscale[status], opacity: 1 };
      case 'optimum':
        return { color: panelNeighGrayscale[status], opacity: 0.5 };
    }
  } else {
    switch (status) {
      case 'null':
      case 'low':
      case 'good':
      case 'gray':
        return { color: panelNormalGrayscale[status], opacity: 1 };
      case 'optimum':
        return { color: panelNormalGrayscale[status], opacity: 0.5 };
    }
  }
};

const getRFIIcon = (iconColor, scale, opacity) => {
  return `data:image/svg+xml;charset=UTF-8,
<svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="50pt" height="50pt" viewBox="0 0 50 50">
  <g transform="scale(${scale})" opacity="${opacity}" transform-origin="center">
    <circle cx="25" cy="25" r="11" fill="%23696967" />
    <circle cx="25" cy="25" r="8" fill="${iconColor}" />
  </g>
</svg>`;
};

const getRFELIcon = (iconColor, scale, opacity) => {
  return `data:image/svg+xml;charset=UTF-8,
<svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="50pt" height="50pt" viewBox="0 0 50 50">
  <g transform="scale(${scale})" opacity="${opacity}" transform-origin="center">
    <circle cx="25" cy="25" r="18" fill="%23696967" />
    <circle cx="25" cy="25" r="13" fill="none" stroke-width="4.5" stroke="${iconColor}" />
    <circle cx="25" cy="25" r="7" fill="${iconColor}" />
  </g>
</svg>`;
};

const getRFEHIcon = (iconColor, scale, opacity) => {
  return `data:image/svg+xml;charset=UTF-8,
<svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="50pt" height="50pt" viewBox="0 0 50 50">
  <g transform="scale(${scale})" opacity="${opacity}" transform-origin="center">
    <circle cx="25" cy="25" r="25" fill="%23696967" />
    <circle cx="25" cy="25" r="21" fill="none" stroke-width="4.5" stroke="${iconColor}" />
    <circle cx="25" cy="25" r="13" fill="none" stroke-width="4.5" stroke="${iconColor}" />
    <circle cx="25" cy="25" r="7" fill="${iconColor}" />
  </g>
</svg>`;
};

// WIFI/Ethernet
const getWifiEthIIcon = (iconColor, scale, opacity) => {
  return `data:image/svg+xml;charset=UTF-8,
<svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="50pt" height="50pt" viewBox="0 0 50 50">
 <g transform="scale(${scale})" opacity="${opacity}" transform-origin="center"> 
    <polygon points="25,13 38,39 12,39" fill="%23696967" />
    <polygon points="25,19 33,36 17,36" fill="${iconColor}" />
  </g>
</svg>`;
};

const getWifiEthELIcon = (iconColor, scale, opacity) => {
  return `data:image/svg+xml;charset=UTF-8,
<svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="50pt" height="50pt" viewBox="0 0 50 50">
 <g transform="scale(${scale})" opacity="${opacity}" transform-origin="center"> 
    <polygon points="25,5 45,45 5,45" fill="%23696967" />
    <polygon points="25,13 39,41.5 11,41.5" fill="none" stroke="${iconColor}" stroke-width="3"/>
    <polygon points="25,21 33,38 17,38" fill="${iconColor}" />
  </g>
</svg>`;
};

const getWifiEthEHIcon = (iconColor, scale, opacity) => {
  return `data:image/svg+xml;charset=UTF-8,
<svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="50pt" height="50pt" viewBox="0 0 50 50">
 <g transform="scale(${scale})" opacity="${opacity}" transform-origin="center"> 
    <polygon points="25,0 50,50 0,50" fill="%23696967" />
    <polygon points="25,4 46.5,48 3,48" fill="none" stroke="${iconColor}" stroke-width="3"/>
    <polygon points="25,15 39,43.5 11,43.5" fill="none" stroke="${iconColor}" stroke-width="3"/>
    <polygon points="25,23 33,40 17,40" fill="${iconColor}" />
  </g>
</svg>`;
};

// Celular
const getCelularIIcon = (iconColor, scale, opacity) => {
  return `data:image/svg+xml;charset=UTF-8,
<svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="50pt" height="50pt" viewBox="0 0 50 50">
 <g transform="scale(${scale})" opacity="${opacity}" transform-origin="center"> 
    <rect x="16" y="16" width="18" height="18" fill="%23696967" transform="rotate(45 25 25)" cx="25" cy="25" />
    <rect x="18" y="18" width="14" height="14" fill="${iconColor}" transform="rotate(45 25 25)" cx="25" cy="25" />
  </g>
</svg>`;
};

const getCelularELIcon = (iconColor, scale, opacity) => {
  return `data:image/svg+xml;charset=UTF-8,
<svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="50pt" height="50pt" viewBox="0 0 50 50">
 <g transform="scale(${scale})" opacity="${opacity}" transform-origin="center"> 
    <rect x="12" y="12" width="26" height="26" fill="%23696967" transform="rotate(45 25 25)" cx="25" cy="25" />
    <rect x="14.5" y="14.5" width="21" height="21" fill="none" stroke="${iconColor}" stroke-width="2.5" transform="rotate(45 25 25)" cx="25" cy="25"/>
    <rect x="18" y="18" width="14" height="14" fill="${iconColor}" transform="rotate(45 25 25)" cx="25" cy="25" />
  </g>
</svg>`;
};

const getCelularEHIcon = (iconColor, scale, opacity) => {
  return `data:image/svg+xml;charset=UTF-8,
<svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="50pt" height="50pt" viewBox="0 0 50 50">
 <g transform="scale(${scale})" opacity="${opacity}" transform-origin="center"> 
    <rect x="8" y="8" width="34" height="34" fill="%23696967" transform="rotate(45 25 25)" cx="25" cy="25" />
    <rect x="10" y="10" width="30" height="30" fill="none" stroke="${iconColor}" stroke-width="2.5" transform="rotate(45 25 25)" cx="25" cy="25"/>
    <rect x="14.5" y="14.5" width="21" height="21" fill="none" stroke="${iconColor}" stroke-width="2.5" transform="rotate(45 25 25)" cx="25" cy="25"/>
    <rect x="18" y="18" width="14" height="14" fill="${iconColor}" transform="rotate(45 25 25)" cx="25" cy="25" />
  </g>
</svg>`;
};

// Full Link
const getFullIIcon = (iconColor, scale, opacity) => {
  return `data:image/svg+xml;charset=UTF-8,
<svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="50pt" height="50pt" viewBox="0 0 50 50">
  <g transform="scale(${scale})" opacity="${opacity}" transform-origin="center"> 
    <polygon points="25,14 38,24 33,39 17,39 12,24" fill="%23696967" stroke="none"/>
    <polygon points="25,17 35.5,25 31,37 19,37 14.5,25" fill="${iconColor}" stroke="none"/>
  </g>
</svg>
`;
};

const getFullELIcon = (iconColor, scale, opacity) => {
  return `data:image/svg+xml;charset=UTF-8,
<svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="50pt" height="50pt" viewBox="0 0 50 50">
  <g transform="scale(${scale})" opacity="${opacity}" transform-origin="center"> 
    <polygon points="25,7 45,21 37,45 13,45 5,21" fill="%23696967" stroke="none"/>
    <polygon points="25,11.5 40.5,22.5 34,41.5 16,41.5 9.5,22.5" fill="none" stroke="${iconColor}" stroke-width="3"/>
    <polygon points="25,17 35.5,25 31,37 19,37 14.5,25" fill="${iconColor}" stroke="none"/>
  </g>
</svg>`;
};

const getFullEHIcon = (iconColor, scale, opacity) => {
  return `data:image/svg+xml;charset=UTF-8,
<svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="50pt" height="50pt" viewBox="0 0 50 50">
  <g transform="scale(${scale})" opacity="${opacity}" transform-origin="center"> 
    <polygon points="25,1 49,19 42,50 8,50 0,19" fill="%23696967" stroke="none"/>
    <polygon points="25,5 46,20 39,47 11,47 3,20" fill="none" stroke="${iconColor}" stroke-width="3"/>
    <polygon points="25,11.5 40.5,22.5 34,41.5 16,41.5 9.5,22.5" fill="none" stroke="${iconColor}" stroke-width="3"/>
    <polygon points="25,17 35.5,25 31,37 19,37 14.5,25" fill="${iconColor}" stroke="none"/>
  </g>
</svg>`;
};

const getFullDeviceIcon = (iconColor, scale) => {
  return `data:image/svg+xml;charset=UTF-8,
<svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="50pt" height="50pt" viewBox="0 0 50 50">
  <g transform="scale(${scale})" transform-origin="center">
    <path d="M6.35 9.81818L4.25 7.95835C5.23333 7.10773 6.38767 6.43386 7.713 5.93676C9.03833 5.43965 10.4673 5.1908 12 5.19023C13.5327 5.18965 14.962 5.44195 16.288 5.94714C17.614 6.45232 18.768 7.13714 19.75 8.0016L17.65 9.81818C16.9167 9.18382 16.0667 8.68642 15.1 8.32599C14.1333 7.96556 13.1 7.78534 12 7.78534C10.9 7.78534 9.86667 7.96556 8.9 8.32599C7.93333 8.68642 7.08333 9.18382 6.35 9.81818ZM2.1 6.14177L0 4.32519C1.53333 2.96996 3.325 1.91029 5.375 1.14618C7.425 0.382058 9.63333 0 12 0C14.3667 0 16.575 0.382058 18.625 1.14618C20.675 1.91029 22.4667 2.96996 24 4.32519L21.9 6.14177C20.6167 5.03164 19.1293 4.16314 17.438 3.53628C15.7467 2.90941 13.934 2.59569 12 2.59511C10.066 2.59454 8.25367 2.90826 6.563 3.53628C4.87233 4.16429 3.38467 5.03279 2.1 6.14177Z" fill="${iconColor}"/>
    <path d="M14.8571 23.5H9.14286C9.01663 23.5 8.86293 23.4369 8.72789 23.2651C8.59056 23.0903 8.5 22.8325 8.5 22.5455V12.3636C8.5 12.0766 8.59056 11.8188 8.72789 11.644C8.86293 11.4722 9.01663 11.4091 9.14286 11.4091H14.8571C14.9834 11.4091 15.1371 11.4722 15.2721 11.644C15.4094 11.8188 15.5 12.0766 15.5 12.3636V22.5455C15.5 22.8325 15.4094 23.0903 15.2721 23.2651C15.1371 23.4369 14.9834 23.5 14.8571 23.5Z" stroke="${iconColor}" stroke-linecap="round" stroke-linejoin="round"/>
    <rect x="10.2856" y="12.9231" width="3.42857" height="7.04895" fill="${iconColor}"/>
  </g>
</svg>`;
};

const getFullDeviceSignalIcon = (iconColor, scale = 1, width = 15, height = 15) => {
  return `data:image/svg+xml;charset=UTF-8,
<svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="${width}pt" height="${height}pt" viewBox="0 1 20 20">
  <g transform="scale(${scale})" transform-origin="center">
    <path d="M15.75 6.75V18.75C15.75 18.9489 15.671 19.1397 15.5303 19.2803C15.3897 19.421 15.1989 19.5 15 19.5C14.8011 19.5 14.6103 19.421 14.4697 19.2803C14.329 19.1397 14.25 18.9489 14.25 18.75V6.75C14.25 6.55109 14.329 6.36031 14.4697 6.21967C14.6103 6.07901 14.8011 6 15 6C15.1989 6 15.3897 6.07901 15.5303 6.21967C15.671 6.36031 15.75 6.55109 15.75 6.75ZM18.75 2.25C18.5511 2.25 18.3603 2.32902 18.2197 2.46967C18.079 2.61031 18 2.80109 18 3V18.75C18 18.9489 18.079 19.1397 18.2197 19.2803C18.3603 19.421 18.5511 19.5 18.75 19.5C18.9489 19.5 19.1397 19.421 19.2803 19.2803C19.421 19.1397 19.5 18.9489 19.5 18.75V3C19.5 2.80109 19.421 2.61031 19.2803 2.46967C19.1397 2.32902 18.9489 2.25 18.75 2.25ZM11.25 9.75C11.0511 9.75 10.8603 9.82901 10.7197 9.96967C10.579 10.1103 10.5 10.3011 10.5 10.5V18.75C10.5 18.9489 10.579 19.1397 10.7197 19.2803C10.8603 19.421 11.0511 19.5 11.25 19.5C11.4489 19.5 11.6397 19.421 11.7803 19.2803C11.921 19.1397 12 18.9489 12 18.75V10.5C12 10.3011 11.921 10.1103 11.7803 9.96967C11.6397 9.82901 11.4489 9.75 11.25 9.75ZM7.5 13.5C7.30109 13.5 7.11031 13.579 6.96967 13.7197C6.82901 13.8603 6.75 14.0511 6.75 14.25V18.75C6.75 18.9489 6.82901 19.1397 6.96967 19.2803C7.11031 19.421 7.30109 19.5 7.5 19.5C7.69891 19.5 7.88969 19.421 8.03033 19.2803C8.17099 19.1397 8.25 18.9489 8.25 18.75V14.25C8.25 14.0511 8.17099 13.8603 8.03033 13.7197C7.88969 13.579 7.69891 13.5 7.5 13.5ZM3.75 17.25C3.55109 17.25 3.36031 17.329 3.21967 17.4697C3.07901 17.6103 3 17.8011 3 18V18.75C3 18.9489 3.07901 19.1397 3.21967 19.2803C3.36031 19.421 3.55109 19.5 3.75 19.5C3.94891 19.5 4.13969 19.421 4.28033 19.2803C4.42099 19.1397 4.5 18.9489 4.5 18.75V18C4.5 17.8011 4.42099 17.6103 4.28033 17.4697C4.13969 17.329 3.94891 17.25 3.75 17.25Z" fill="${iconColor}"/>
  </g>
</svg>`;
};

const getFullReceiverIcon = (iconColor, scale = 1, width = 15, height = 15) => {
  return `data:image/svg+xml;charset=UTF-8,
<svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="${width}pt" height="${height}pt" viewBox="0 2 20 20">
  <path d="M12.4266 2.91333C13.0264 3.77867 13.573 4.67979 14.0633 5.6117C14.1355 5.60148 14.2082 5.59631 14.2812 5.59623C14.5752 5.59629 14.8634 5.67925 15.1127 5.83561C15.3618 5.99197 15.562 6.21542 15.6903 6.48036C16.3875 6.41796 17.0867 6.38101 17.7867 6.36958C18.1898 6.36345 18.5948 6.36568 19.0016 6.37627C17.4603 4.3875 15.1033 3.06654 12.4266 2.91333ZM11.1573 2.93005C11.1267 2.93256 11.0957 2.93423 11.0651 2.93695C10.3603 4.3804 9.80896 5.80671 9.41491 7.21441C9.58391 7.31909 9.73146 7.455 9.84968 7.61488C10.7997 7.32735 11.7636 7.08806 12.7377 6.89797C12.7897 6.59578 12.9291 6.31549 13.1387 6.0918C12.5755 5.0229 11.917 3.96864 11.1573 2.93005ZM9.81251 3.14366C7.63523 3.66271 5.7305 4.97781 4.47247 6.83067C5.43631 7.05204 6.39055 7.31339 7.33273 7.61405C7.45965 7.44281 7.62014 7.2993 7.80436 7.19228C7.9886 7.08525 8.1927 7.01697 8.4042 6.9916C8.75399 5.71599 9.22342 4.43223 9.81251 3.14366ZM18.4 7.4113C17.5267 7.40566 16.6626 7.4414 15.8068 7.51581C15.7307 7.8463 15.5496 8.14319 15.2906 8.3619C15.5786 9.137 15.8238 9.92736 16.0251 10.7294C16.2296 10.7511 16.428 10.813 16.6086 10.9115C16.7893 11.01 16.9488 11.1431 17.0782 11.3033C18.2887 10.9406 19.5216 10.6568 20.7689 10.4537C20.6008 9.39775 20.2445 8.38063 19.717 7.45081C19.2757 7.42753 18.8367 7.41451 18.4 7.4113ZM3.91198 7.77958C3.46004 8.66022 3.15764 9.60999 3.01717 10.59C4.33109 9.83502 5.66736 9.17621 7.02659 8.61731L7.02617 8.61104C6.01714 8.28874 4.97761 8.01431 3.91198 7.77958ZM12.9111 7.92255C11.9818 8.10393 11.0623 8.33204 10.156 8.60603C10.1553 8.62381 10.1544 8.64158 10.1531 8.65933C11.7717 9.34574 13.3264 10.1742 14.799 11.1349C14.8674 11.072 14.9413 11.0154 15.0198 10.9656C14.8286 10.2083 14.5961 9.46212 14.3231 8.73039L14.2812 8.73122C14.0014 8.73111 13.7269 8.65603 13.486 8.51379C13.2451 8.37154 13.0465 8.16753 12.9111 7.92255ZM7.41501 9.58212C5.89226 10.2104 4.39603 10.9706 2.92466 11.8556L2.92383 11.8846C2.92383 14.2603 3.84119 16.4156 5.33909 18.0206C6.19337 17.2557 7.0848 16.5333 8.01015 15.8563C7.61757 13.9127 7.56056 11.9258 7.81783 9.91089C7.66617 9.82474 7.53016 9.7132 7.41501 9.58212ZM9.73713 9.61598C9.49655 9.87463 9.1757 10.0443 8.82666 10.0975C8.60698 11.8313 8.63829 13.535 8.93274 15.2066C10.6363 14.0498 12.4226 13.077 14.2937 12.2985V12.2886C14.2938 12.2124 14.2995 12.1362 14.3108 12.0608C12.8633 11.109 11.3325 10.2907 9.73713 9.61598ZM20.8729 11.4959C19.7084 11.6887 18.5572 11.9545 17.426 12.2918C17.4256 12.5191 17.3758 12.7435 17.2801 12.9495C18.2742 13.7627 19.2139 14.6405 20.0927 15.5772C20.615 14.4165 20.8843 13.1577 20.8827 11.8846C20.8827 11.7542 20.8785 11.6248 20.8729 11.4959ZM14.6461 13.2783C12.73 14.0791 10.9059 15.0932 9.16683 16.3103C9.54689 17.844 10.1519 19.35 10.9896 20.8264C11.2901 20.857 11.5946 20.8722 11.9033 20.8722C13.1211 20.8722 14.2812 20.6298 15.339 20.1921C15.6926 18.0154 15.7622 15.8924 15.5337 13.8213C15.1847 13.7468 14.8716 13.5552 14.6461 13.2783ZM16.5634 13.7089C16.7785 15.6423 16.7461 17.6153 16.4778 19.6223C17.7463 18.8708 18.811 17.819 19.5784 16.5592C18.6441 15.5369 17.6364 14.5841 16.5634 13.7089ZM8.27097 16.9605C7.52234 17.5251 6.79718 18.1203 6.09732 18.7445C7.1354 19.6268 8.36122 20.2601 9.68117 20.5959C9.07161 19.4053 8.60321 18.1922 8.27097 16.9605Z" fill="${iconColor}"/>
</svg>`;
};

const getFullMonitoringIcon = (iconColor, scale = 1, width = 13, height = 13) => {
  return `data:image/svg+xml;charset=UTF-8,
<svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="${width}pt" height="${height}pt" viewBox="0 1 22 22">
  <g transform="scale(${scale})" transform-origin="center">
    <path d="M11.7825 0.998535L2.99121 4.29528V10.9877C2.99121 16.5372 6.73852 21.7131 11.7825 22.9769C16.8266 21.7131 20.5739 16.5372 20.5739 10.9877V4.29528L11.7825 0.998535ZM18.376 10.9877C18.376 15.3833 15.5738 19.4493 11.7825 20.6911C7.99128 19.4493 5.18904 15.3943 5.18904 10.9877V5.82278L11.7825 3.35022L18.376 5.82278V10.9877Z" fill="${iconColor}"/>
    <path d="M11.691 12.4456C10.9984 12.4456 10.4056 12.199 9.91241 11.7059C9.41923 11.2127 9.17265 10.6199 9.17265 9.92728C9.17265 9.23474 9.41923 8.64187 9.91241 8.1487C10.4056 7.65552 10.9984 7.40894 11.691 7.40894C12.3835 7.40894 12.9764 7.65552 13.4696 8.1487C13.9627 8.64187 14.2093 9.23474 14.2093 9.92728C14.2093 10.6199 13.9627 11.2127 13.4696 11.7059C12.9764 12.199 12.3835 12.4456 11.691 12.4456ZM6.6543 17.4823V15.7195C6.6543 15.3627 6.74622 15.035 6.93006 14.736C7.1139 14.4372 7.35776 14.2089 7.66164 14.0511C8.31221 13.7258 8.97328 13.4819 9.64483 13.3195C10.3164 13.1571 10.9984 13.0757 11.691 13.0752C12.3835 13.0748 13.0656 13.1563 13.7372 13.3195C14.4087 13.4827 15.0698 13.7266 15.7204 14.0511C16.0247 14.2085 16.2687 14.4368 16.4526 14.736C16.6364 15.0353 16.7282 15.3632 16.7277 15.7195V17.4823L11.691 22.0611L6.6543 17.4823Z" fill="${iconColor}"/>
  </g>
</svg>`;
};

const getRedirectDeviceIcon = (color = 'white', scale = 1, width = 14, height = 14) => {
  return `data:image/svg+xml;charset=UTF-8,
<svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="${width}pt" height="${height}pt" viewBox="0 0 24 24">
  <g transform="scale(${scale})" transform-origin="center">
    <path d="M7.24401 23.5973C7.44317 23.7965 7.6899 23.896 7.98428 23.896H9.31414C9.88795 23.896 10.3531 23.4309 10.3531 22.8571C10.3531 22.2833 9.88795 21.8181 9.31414 21.8181H9.02325V11.4285H13.1791V14.9194C13.1791 15.4932 13.6442 15.9584 14.218 15.9584C14.7919 15.9584 15.257 15.4932 15.257 14.9194V10.3896C15.257 10.0952 15.1575 9.84841 14.9583 9.64928C14.7592 9.45015 14.5124 9.35059 14.218 9.35059H7.98428C7.6899 9.35059 7.44317 9.45015 7.24401 9.64928C7.04488 9.84841 6.94531 10.0952 6.94531 10.3896V22.8571C6.94531 23.1514 7.04488 23.3982 7.24401 23.5973Z" fill="${color}"/>
    <path d="M12.0255 14.4286C11.7744 14.6796 11.467 14.8052 11.1034 14.8052C10.7398 14.8052 10.4324 14.6796 10.1813 14.4286C9.93021 14.1775 9.80469 13.8701 9.80469 13.5065C9.80469 13.1428 9.93021 12.8355 10.1813 12.5844C10.4324 12.3333 10.7398 12.2078 11.1034 12.2078C11.467 12.2078 11.7744 12.3333 12.0255 12.5844C12.2766 12.8355 12.4021 13.1428 12.4021 13.5065C12.4021 13.8701 12.2766 14.1775 12.0255 14.4286Z" fill="${color}"/>
    <path d="M5.96094 6.28562L7.41548 7.74018C7.91764 7.23801 8.48474 6.86139 9.11677 6.61029C9.74882 6.35922 10.4111 6.23368 11.1038 6.23368C11.7964 6.23368 12.4588 6.35922 13.0908 6.61029C13.7228 6.86139 14.2899 7.23801 14.7921 7.74018L16.2467 6.28562C15.554 5.59299 14.7661 5.06484 13.883 4.70122C12.9999 4.33756 12.0735 4.15576 11.1038 4.15576C10.1341 4.15576 9.20768 4.33756 8.32458 4.70122C7.44146 5.06484 6.65358 5.59299 5.96094 6.28562Z" fill="${color}"/>
    <path d="M3 3.32467L4.5065 4.83117C5.3723 3.93074 6.37663 3.24674 7.51948 2.77921C8.66233 2.31169 9.85714 2.07792 11.1039 2.07792C12.3506 2.07792 13.5455 2.31169 14.6883 2.77921C15.8312 3.24674 16.8355 3.93074 17.7013 4.83117L19.1559 3.37663C18.0996 2.28572 16.8745 1.45022 15.4805 0.870129C14.0866 0.290042 12.6277 0 11.1039 0C9.58009 0 8.12121 0.290042 6.72727 0.870129C5.33332 1.45022 4.09091 2.2684 3 3.32467Z" fill="${color}"/>
    <path d="M15.2062 22.9398C15.0898 23.0563 15.0243 23.2143 15.0243 23.379C15.0243 23.5437 15.0897 23.7017 15.2062 23.8181C15.3227 23.9346 15.4806 24 15.6453 24C15.81 24 15.968 23.9346 16.0845 23.8181L19.0166 20.8861C19.0743 20.8284 19.1201 20.7599 19.1513 20.6846C19.1826 20.6092 19.1986 20.5284 19.1986 20.4468C19.1986 20.3652 19.1826 20.2844 19.1513 20.209C19.1201 20.1337 19.0743 20.0652 19.0166 20.0076L16.0845 17.0755C15.968 16.959 15.81 16.8936 15.6453 16.8936C15.4806 16.8936 15.3227 16.959 15.2062 17.0755C15.0897 17.1919 15.0243 17.3499 15.0243 17.5146C15.0243 17.6793 15.0897 17.8373 15.2062 17.9538L17.0787 19.8259H11.4099C11.2453 19.8259 11.0873 19.8913 10.9709 20.0078C10.8545 20.1242 10.7891 20.2821 10.7891 20.4468C10.7891 20.6115 10.8545 20.7694 10.9709 20.8858C11.0873 21.0023 11.2453 21.0677 11.4099 21.0677H17.0787L15.2062 22.9398Z" fill="${color}"/>
  </g>
</svg>`;
};

const getFullClusterIcon = (color, count, width, height, opacity = 0.6, radius = 70) => {
  return `<svg fill="${color}" xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 240 240">
  <circle cx="120" cy="120" opacity="${opacity}" r="${radius}" />
  <circle cx="120" cy="120" opacity="${opacity - 0.3}" r="${radius + 20}" />
  <circle cx="120" cy="120" opacity="${opacity - 0.4}" r="${radius + 40}" />
  <text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="75" dominant-baseline="middle" font-family="Dm Sans,sans-serif">${count}</text>
  </svg>`;
};

export default {
  getIconCode,
  getFullClusterIcon,
  clusterColors,
  panelNeighColors,
  panelNormalColors,
  getRedirectDeviceIcon,
};
